export function showElement(el, forceHide) {
  if (el.style.display === 'none') { el.style.display = ''; }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/showElement.js
// module id = 90
// module chunks = 0